<template>
  <section class="section-summary-mobile"
           ref="sectionSummaryMobile"
           v-if="preBookingData">
    <div class="d-flex justify-content-start align-items-center">
      <div class="flex-fill text-remark text-sm text-dark">
        <div>
          <span v-html="$options.filters.serviceParentName(preBookingData.service_id, globalState.services)"></span> - 
          {{ globalState.cities[preBookingData.province_id] | multiLangName }}
        </div>
        <div>
          <span v-if="preBookingData.cleaning_date">
            {{ preBookingData.cleaning_date | summaryCleaningDate }} ({{ preBookingData.cleaning_time }})
          </span>
          <span v-else>
            {{ $t('message.booking.new_booking.booking_type_flexible') }}
          </span>
            -
          <span v-if="preBookingData.service_id === 1">
            {{ $t(globalState.allWorkHours[preBookingData.work_hour]) }}
          </span>
          <span v-else-if="preBookingData.service_items">
            {{ getServiceItemsCount() }} {{ preBookingData.service_items[0].item_unit | multiLangName }}
          </span>
          <span v-else>
            {{ globalState.services[preBookingData.service_id] | multiLangName }}
          </span>
        </div>
      </div>
      <div class="text-primary">
        {{ (state.currentStep === 3) ? totalPrice : state.totalPrice | currency }}
      </div>
    </div>
  </section>
</template>

<script>
  import { checkoutCostMixin } from '../../../mixins/checkoutCostMixin'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [checkoutCostMixin],
    computed: {
      ...mapGetters({
        appliedExtras: 'extras/getAppliedExtras',
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        globalState: 'globalVal/getState',
        hasAppliedExtras: 'extras/getHasAppliedExtras',
        preBookingData: 'booking/getPreBookingData',
        selectedProfessional: 'booking/getSelectedProfessional',
        state: 'booking/getState'
      })
    },
    methods: {
      unselectProfessional () {
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
      },
      handleScroll () {
        if (this.$refs.sectionSummaryMobile) {
          if (window.scrollY > 96) {
            this.$refs.sectionSummaryMobile.classList.add('fix-sidebar')
          } else {
            this.$refs.sectionSummaryMobile.classList.remove('fix-sidebar')
          }
        }
      },
      getServiceItemsCount () {
        let count = 0
        for (const serviceItem of this.preBookingData.service_items) {
          count += serviceItem.count
        }
        return count
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/SummaryBookingSelectProfessional.vue